import { useRef } from "react";
import { INDUSTRIES } from "../data/content";
import { useReveal } from "../hooks/useReveal";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function Industries() {
  const scrollRef = useRef(null);
  const ref = useReveal();

  const scrollBy = (delta) => {
    scrollRef.current?.scrollBy({ left: delta, behavior: "smooth" });
  };

  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative py-24 lg:py-40 bg-[#F3F0EA]"
    >
      <div ref={ref} className="reveal max-w-[90rem] mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <p className="overline mb-6 flex items-center gap-3">
              Industries We Serve
            </p>
            <h2
              data-testid="industries-headline"
              className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-stone-900"
            >
              Fluency across
              <em className="italic text-[#4A6076]"> ten disciplines</em>.
            </h2>
          </div>
          <div className="flex gap-3">
            <button
              data-testid="industries-prev"
              onClick={() => scrollBy(-400)}
              className="w-12 h-12 border border-stone-400 rounded-full flex items-center justify-center text-stone-800 hover:bg-stone-900 hover:text-white transition-colors"
              aria-label="Previous"
            >
              <ArrowLeft size={16} strokeWidth={1.4} />
            </button>
            <button
              data-testid="industries-next"
              onClick={() => scrollBy(400)}
              className="w-12 h-12 border border-stone-400 rounded-full flex items-center justify-center text-stone-800 hover:bg-stone-900 hover:text-white transition-colors"
              aria-label="Next"
            >
              <ArrowRight size={16} strokeWidth={1.4} />
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          data-testid="industries-carousel"
          className="flex gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth -mx-6 md:-mx-12 px-6 md:px-12 pb-4"
          style={{ scrollbarWidth: "none" }}
        >
          {INDUSTRIES.map((ind, i) => (
            <article
              key={ind.name}
              data-testid={`industry-card-${i}`}
              className="relative snap-start shrink-0 w-[80vw] sm:w-[420px] lg:w-[380px] aspect-[3/4] rounded-sm overflow-hidden img-zoom card-lift bg-stone-900"
            >
              <img
                src={ind.image}
                alt={ind.name}
                loading="lazy"
                className="w-full h-full object-cover opacity-90"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="absolute inset-0 p-6 flex flex-col justify-between text-white">
                <span className="text-[11px] tracking-[0.3em] uppercase text-white/80">
                  0{i < 9 ? i + 1 : i + 1}
                </span>
                <div>
                  <p className="text-[11px] tracking-[0.3em] uppercase text-white/70 mb-2">
                    Sector
                  </p>
                  <h3 className="font-serif-display text-3xl leading-tight">
                    {ind.name}
                  </h3>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
